
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M326.3,285H72.81l28.29-56.59H298Zm28.31,41.87H44.51V800H354.6V326.85ZM269.72,72.48V38.65H129.4V186.54H269.72V152.7H221.3V72.48Z"}}),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M446.46,57A96.84,96.84,0,0,1,607,32.46a69.43,69.43,0,0,1,102.87,86.05,111.29,111.29,0,1,1-176,75.34,96.75,96.75,0,0,1-75.28-37"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M459,36.25S422.47,99.42,342.68,99.42H249.59v28.26l93.09,2.21s86,4.77,130.77,42.11"}})])])])
          )
        }
      }
    